import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from 'recharts';
import { formatKurs } from 'core/utils/format';

// Ruhige, gut unterscheidbare Farbpalette fuer die Kategorie-Segmente.
const FARBEN = ['#10b981', '#14b8a6', '#3b82f6', '#8b5cf6', '#f59e0b', '#ef4444', '#f97316', '#6366f1', '#84cc16', '#ec4899'];

/** Donut-Diagramm der Ausgaben je Kategorie (Recharts). */
export default function KategorieDonut({ kategorien }) {
  const daten = kategorien.map((k) => ({ name: k.kategorie, value: k.betrag }));
  return (
    <ResponsiveContainer width="100%" height={260}>
      <PieChart>
        <Pie data={daten} dataKey="value" nameKey="name" innerRadius={60} outerRadius={95} paddingAngle={2}>
          {daten.map((eintrag, i) => (
            <Cell key={eintrag.name} fill={FARBEN[i % FARBEN.length]} />
          ))}
        </Pie>
        <Tooltip formatter={(wert) => formatKurs(wert)} />
        <Legend />
      </PieChart>
    </ResponsiveContainer>
  );
}
